<div *ngIf="config" class="eidos-filter-wrapper eidos-daterange-filter-wrapper">
  <p class="eidos-filter-label eidos-daterange-filter-label" *ngIf="config.label">{{ config.label }}</p>
  <eidos-input-datetimerange [cssClass]="cssClass" [cssId]="cssId" [disabled]="!!config.disabled" [layoutDirection]="config.layoutDirection"
    [(value)]="realValue" [from]="config.from" (valueChange)="emitOnValueChange()"
    [(otherValue)]="realOtherValue" [to]="config.to" (otherValueChange)="emitOnValueChange()"
    (onFocusIn)="(!!config.onFocusIn && config.onFocusIn())" (onFocusOut)="(!!config.onFocusOut && config.onFocusOut())">
  </eidos-input-datetimerange>
</div>
